module.exports = __webpack_public_path__ + "img/shutterstock_554446720-768x509.e4b9e7eb.jpg";